import { exampleSlice } from 'store/slices/exampleSlice';

export const slices = {
  [exampleSlice.name]: exampleSlice.reducer,
};
